import { Button, ButtonProps, Row } from "antd";
import styles from "./HeaderTable.module.scss";

interface button extends ButtonProps {}
export type HeaderTableProps = {
  title: string;
  buttons?: button[];
};
const HeaderTable = (HeaderTableProps: HeaderTableProps) => {
  //Define const
  const props = HeaderTableProps;

  //Function to render
  const renderButtons = () => {
    return (
      <Row className={styles.ListButton}>
        {props.buttons &&
          props.buttons.length > 0 &&
          props.buttons.map((button: button, key) => {
            return (
              <Button
                key={key}
                {...button}
                className={[styles.Button, button.className].join(" ")}
              />
            );
          })}
      </Row>
    );
  };
  //Main render
  return (
    <div className={styles.HeaderTable}>
      <Row justify="space-between" align="middle">
        <div className={styles.Title}>{props.title}</div>
        <div>{renderButtons()}</div>
      </Row>
    </div>
  );
};

export { HeaderTable };
